import { DomUtils } from "../utils/domUtils";

export const CloakServiceConstants = Object.freeze({
	cloakClass: "cloak",
	blockUi: "blockUi"
});

const _DeCloakPromiseActions = {
	resolve: null,
	reject: null
};

const _DeCloakPromise = new Promise((resolve, reject) => {
	_DeCloakPromiseActions.resolve = resolve;
	_DeCloakPromiseActions.reject = reject;
});

export class CloakService {
	static DeCloak() {
		const cloaks = Array.from(document.getElementsByClassName(CloakServiceConstants.cloakClass));
		cloaks.forEach((c) => c.classList.remove(CloakServiceConstants.cloakClass));

		_DeCloakPromiseActions.resolve();
	}

	static Ready() {
		return _DeCloakPromise;
	}

	static Block() {
		try {
			DomUtils.ShowHide(true, CloakServiceConstants.blockUi);
		}
		catch {
			// ignore
		}
	}

	static Unblock() {
		setTimeout(() => {
			try {
				DomUtils.ShowHide(false, CloakServiceConstants.blockUi);
			}
			catch {
				// ignore
			}
		}, 500);
	}
}
